import { useEffect, useState } from "react";
import extendDataFetcher from "service/extend-data-fetcher";

const generateUserRoute = serviceData => {
    const id = serviceData.payer_user_id || serviceData.receiver_user_id;

    switch (serviceData.financial_user_type_id) {
        case 1:
            return {
                url: `/api/identity/user/get?id=${id}`
            }
        case 2:
            return {
                url: `/api/identity/provider/get?id=${id}`
            }
        case 3:
            return {
                url: `/api/financial/system_type/get?id=${id}`
            }
        case 4:
            return {
                url: `/api/identity/admin/get?id=${id}`
            }
        default:
            return {};
    }
}

const useExtendData = (isLoading, error, data) => {
    const [localData, setLocalData] = useState({});

    useEffect(() => {
        if (!isLoading && !error)
            fetcher(data.data);
    }, [isLoading, error, data])

    const fetcher = async serviceData => {
        const routes = [
            {
                identifier: "incomeType",
                url: serviceData.income_type_id ? `/api/financial/income_type/get?id=${serviceData.income_type_id}` : null,
                key: "title"
            },
            {
                identifier: "user",
                ...generateUserRoute(serviceData)
            },
            {
                identifier: "factorLayer",
                url: serviceData.factor_layer_id ? `/api/shop/setting/factor_layer/get?id=${serviceData.factor_layer_id}` : null,
                key: "title"
            }
        ];

        const newData = await extendDataFetcher(routes);
        setLocalData(newData);
    }

    return localData;
}

export default useExtendData;